import React from "react";

function SpaceIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.7636 1C17.7636 0.593404 17.4218 0.263793 17.0001 0.263793L10.1282 0.263792C9.70651 0.263792 9.36466 0.593403 9.36466 0.999999C9.36466 1.4066 9.70651 1.73621 10.1282 1.73621H16.2366V7.62586C16.2366 8.03246 16.5784 8.36207 17.0001 8.36207C17.4218 8.36207 17.7636 8.03246 17.7636 7.62586L17.7636 1ZM11.0865 7.74299L17.54 1.52058L16.4602 0.479423L10.0067 6.70184L11.0865 7.74299Z"
        // fill={color}
      />
      <path
        d="M0.236607 17C0.236606 17.4066 0.578457 17.7362 1.00015 17.7362L7.87204 17.7362C8.29374 17.7362 8.63559 17.4066 8.63559 17C8.63559 16.5934 8.29374 16.2638 7.87204 16.2638H1.76369V10.3741C1.76369 9.96754 1.42184 9.63793 1.00015 9.63793C0.578456 9.63793 0.236606 9.96754 0.236606 10.3741L0.236607 17ZM6.91371 10.257L0.460243 16.4794L1.54006 17.5206L7.99352 11.2982L6.91371 10.257Z"
        // fill={color}
      />
    </svg>
  );
}

export default SpaceIcon;
